import { render } from "./MessageComposer.vue?vue&type=template&id=3c90713f&scoped=true"
import script from "./MessageComposer.vue?vue&type=script&lang=js"
export * from "./MessageComposer.vue?vue&type=script&lang=js"

import "./MessageComposer.vue?vue&type=style&index=0&id=3c90713f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c90713f"]])

export default __exports__